import { useContext, useEffect } from 'react';
import { useFavorites } from '~/context/common/UserContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import useGetFavoritesCommon from '~/hooks/common/favorites/useGetFavorites';

export default function useGetFavorites() {
  const { setFavorite } = useContext(UserVehicleContext);
  const favorites = useFavorites();
  const currentVehicleId = useGetVehicleId();

  const currentVehicle = favorites.find(
    vehicle => vehicle.vehicleId === currentVehicleId
  );

  useGetFavoritesCommon();

  useEffect(() => {
    setFavorite(
      Boolean(currentVehicle),
      currentVehicle?.subscribeToWIPNotifications
    );
  }, [currentVehicle, setFavorite]);
}
